<template>
  <v-data-table
    dense
    :headers="headers"
    :items="list"
    :item-key="'staff_id'"
    class="elevation-0"
    no-action
  >
    <template slot="items" slot-scope="props">
      <td v-for="head in headers" :key="head.value">
        <div v-if="head.value === 'enable_print_label'" class="mt-4">
          <v-checkbox
            v-model="props.item[head.value]"
            :label="props.item[head.value] ? 'YES' : 'NO'"
          ></v-checkbox>
        </div>
        <div v-else-if="head.value === 'status'" class="mt-4">
          <v-checkbox
            v-model="props.item[head.value]"
            :label="props.item[head.value] ? 'Active' : 'Inactive'"
          ></v-checkbox>
        </div>
        <div
          v-else-if="['class'].includes(head.value) && props.item[head.value]"
        >
          {{ props.item[head.value] || "N/A" }}
        </div>
        <div v-if="!['enable_print_label', 'status'].includes(head.value)">
          {{ props.item[head.value] || "N/A" }}
        </div>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    headers: [],
    list: []
  }
};
</script>
